import React from 'react';

/**
 * A link that leaves the page (KPR-1668; docs/plans/ios-app.md, Decision 2).
 *
 * ONE place writes `target="_blank"`. src/__tests__/platformSeam.test.js fails
 * on one written anywhere else, because in the phone app a WebView has no tabs:
 * every such link must reach `platform.openExternal`, and
 * platform/externalLinks.js does that for them from one document listener (it
 * does nothing in a browser, where the anchor opens its own tab and a
 * middle-click, a Ctrl-click and "Open link in new tab" keep working).
 *
 * Use the component for a plain anchor. For a component that renders its own
 * anchor (antd `Button`/`Typography.Link` with an `href`, a router `Link`,
 * `RecordBadge`) spread `EXTERNAL_LINK_PROPS` on it:
 *
 *     <Button href={url} {...EXTERNAL_LINK_PROPS}>Open</Button>
 *
 * `noopener noreferrer` is part of it: the page opened never gets a handle on
 * this one. A link that also asks search engines not to follow passes `rel`.
 */
export const EXTERNAL_LINK_PROPS = Object.freeze({ target: '_blank', rel: 'noopener noreferrer' });

const ExternalLink = React.forwardRef(function ExternalLink({ rel = EXTERNAL_LINK_PROPS.rel, children, ...rest }, ref) {
	return <a ref={ref} {...rest} target={EXTERNAL_LINK_PROPS.target} rel={rel}>{children}</a>;
});

export default ExternalLink;
